import React, { Fragment, useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import ZoomInIcon from '@material-ui/icons/ZoomIn';


const ReactTableActionsCHPatient = ({ data, refresh,callbackUpdate, generateClinicEvent }) => {

const onToggleWacthClinicEvent = (history) => {
    generateClinicEvent(history)
}
    return (<Fragment>
        <td role="cell">

            <Tooltip title="ver Evento Clinico">
                <IconButton aria-label="edit" onClick={() => {
                    onToggleWacthClinicEvent(data.data.original);
                }}>
                    <ZoomInIcon />
                </IconButton>
            </Tooltip>                                
            {/* <Tooltip title="Ver Perfil">
                <IconButton aria-label="edit" onClick={() => {
                    watchPatientProfile(data.data.original.num);
                }}>
                    <ZoomInIcon />
                </IconButton>
            </Tooltip>  
            <Modal
                color='warning'
                title='¿Esta seguro que desea eliminar este paciente?'
                modal={isdelete}
                onOk={onDelet}
                toggle={() => setIsdeleted(!isdelete)}
            /> */}
        </td>
    </Fragment>)
}

export default ReactTableActionsCHPatient;